export default function formatDateTime(dateString, formatType = 'short-date') {
  if (dateString == null) return '';

  switch (formatType) {
    case 'short-date':
    default:
      return new Date(dateString).toLocaleDateString();
  }
}
